import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {

  constructor(
    private _utilsService: UtilsService,
    private _router: Router,
    private _aRoute: ActivatedRoute,
    private _title: Title
  ) { }

  ngOnInit(): void {
    this._title.setTitle('Estudei | Vídeo de Lançamento');

    //Flag de Lançamento
    const launchKey = localStorage.getItem('launchKey') || 'NO';
    if (launchKey != 'SEMENTE') {
      this._utilsService.getLaunchKey().subscribe(
        next => {
          localStorage.setItem('launchKey', next.value);
          if (next.value == 'SEMENTE') this._router.navigate([''], { relativeTo: this._aRoute });
        }
      );
    } else {
      this._router.navigate([''], { relativeTo: this._aRoute });
    }
  }

}
